import * as React from "react";
import Treatment from "../model/treatment/Treatment";
import TreatmentAssignment from "../model/treatment/TreatmentAssignment";
import "./AssignedTreatmentItem.scss";
import Draggable from "../../../resources/images/icons/drag-drop.svg";

interface AssignedTreatmentEditorProps {
  assignment: TreatmentAssignment;
  onDelete?: (assignment: Treatment) => any;
  onToggleAutoAssign?: (assignmentUid: string) => any;
}

export default class AssignedTreatmentItem extends React.Component<AssignedTreatmentEditorProps> {
  render() {
    return (
      <div className="h-flex space-between assignment-row">
        <span className="assignment-item">
          <img className="draggable action" src={Draggable} alt={"draggable-img"} />
          <i
            className={
              " clickable action" +
              (this.props.assignment.isAutoAssigned ? " ic_favori_full" : " ic_favori")
            }
            onClick={() => this.props.onToggleAutoAssign(this.props.assignment.treatment.uid)}
            title={i18n["Form.EditAssignment.AutoAssignedTreatments.Label"]}
          />
          <span>{this.props.assignment.treatment.name}</span>
        </span>
        {this.props.onDelete && (
          <i
            className="ic_close clickable action"
            onClick={() => this.props.onDelete(this.props.assignment.treatment)}
            title={i18n["Global.Remove"]}
          />
        )}
      </div>
    );
  }
}
